module.exports = __webpack_public_path__ + "static/vertex-downhole-a24351f88012eebcaa9614481ad59da0.png";